import React from "react";
import { Box, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";

interface UnpassableErrorProps {
  title?: string;
  subtitle: string;
}

export function UnpassableError({
  title = "Oh, snap!",
  subtitle,
}: UnpassableErrorProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Warning
        sx={{
          fontSize: "4rem",
          color: "gray",
        }}
      />

      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{
          marginTop: "1rem",
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          marginTop: "1rem",
          color: "gray",
          textAlign: "center",
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}
